import React from "react";
export default function Main({ src, title, subtitle, button, onClick = () => {}, classNameSubtitle = "" }) {
   return (
      <div className="main-container-provider-verification">
         <div className="container-content-provider-verification">
            <img className="image-provider-verification" src={src} alt="Provider Email Verification" />
            <div className="title-provider-verification">{title}</div>
            <div className={`subtitle-provider-verification ${classNameSubtitle} `}>{subtitle}</div>
            {button && (
               <button onClick={onClick} className="button-provider-verification">
                  {button}
               </button>
            )}
         </div>
      </div>
   );
}
